module.exports = __webpack_public_path__ + "img/in.c3f1fe11.svg";